import React from 'react';
import { ButtonType } from '../../../SharedComponents/Button/ButtonType';
import CustomButton from '../../../SharedComponents/Button/CustomButton';
import AppContainer from '../../../SharedComponents/Container/AppContainer';
import BodyContainer from '../../../SharedComponents/Container/BodyContainer';
import Header from '../../../SharedComponents/Header/HeaderRefactor';
import CustomTypography, {
    TypographyType,
} from '../../../SharedComponents/Typography/CustomTypography';
import './FineTuningInfoPage.scss';
import useFineTuningInfoPageHandler from './FineTuningInfoPageHandlerHook';
import useFineTuningInfoPageResource from './FineTuningInfoPageResourceHook';

const FineTuningInfoPage = (): JSX.Element => {
    const {
        headerText,
        instruction1,
        instruction2,
        instructionBullet,
        instruction3,
        buttonText,
    } = useFineTuningInfoPageResource();
    const { goStart } = useFineTuningInfoPageHandler();
    return (
        <AppContainer>
            <Header
                headerContent={{ text: headerText, id: 'header-fine-tuning' }}
            />
            <BodyContainer>
                <CustomTypography
                    id={'txt-fine-tuning-info-instruction1'}
                    type={TypographyType.notoSansSubHeading}
                    text={instruction1}
                    className={'finetuninInfoSubHeading'}
                />
                <CustomTypography
                    id={'txt-fine-tuning-info-instruction2'}
                    type={TypographyType.notoSansBody16px}
                    text={instruction2}
                    className={'noTopMargin fineTuningInfoBulletList'}
                />
                <CustomTypography
                    id={'txt-fine-tuning-info-instructionBullet'}
                    type={TypographyType.notoSansBody16px}
                    text={instructionBullet}
                    className={'noTopMargin fineTuningInfoBulletList'}
                />
                <CustomTypography
                    id={'txt-fine-tuning-info-instruction3'}
                    type={TypographyType.notoSansBody16px}
                    text={instruction3}
                    className={'noTopMargin fineTuningInfoBulletList'}
                />
            </BodyContainer>
            <CustomButton
                id={'btn-got-it'}
                buttonType={ButtonType.Primary}
                onClick={goStart}
                className={'fineTuningInfoButton'}
            >
                {buttonText}
            </CustomButton>
        </AppContainer>
    );
};

export default FineTuningInfoPage;
